import $ from 'jquery';
import { getParams } from './util/urlParam';
import { exhibitioninfo, langList } from './variables';
import { getShowsJqXHR,} from './api';
import { Shows, } from './model/index';
import translate, { Lang, t } from './util/translate';

$(() => {
  $('#loading').show(); // ロードを開始

  localStorage.removeItem("phoneNumber")
  localStorage.removeItem("emailAddress")

  translate(); // 翻訳
  
  // ローカルストレージ非対応環境
  if (!window.localStorage) {
    alert("お使いのブラウザは対応してません。Chromeなどの他ブラウザをご利用ください。");
  }

  // クエリ取得
  const params = getParams(exhibitioninfo);

  // 言語設定 クエリ優先 -> localStorage
  let lang = 'ja' as keyof Lang
  if (langList.indexOf(String(params.lang)) !== -1) {
    lang = params.lang as keyof Lang;
    localStorage.setItem('lang', lang);
  }else{
    lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
  }

  // フッター問い合わせ
  let contactlist: string = 
  `
  <dd><span>`+ t.footer_tigs[lang] + t.footertel_tigs[lang] +`</span> <a href="mailto:`+ t.footermail_tigs[lang] +`">`+ t.footermail_tigs[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_ld[lang] + t.footertel_ld[lang] +`</span> <a href="mailto:`+ t.footermail_ld[lang] +`">`+ t.footermail_ld[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_landd[lang] + t.footertel_landd[lang] +`</span> <a href="mailto:`+ t.footermail_landd[lang] +`">`+ t.footermail_landd[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_gds[lang] + t.footertel_gds[lang] +`</span> <a href="mailto:`+ t.footermail_gds[lang] +`">`+ t.footermail_gds[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_pi[lang] + t.footertel_pi[lang] +`</span> <a href="mailto:`+ t.footermail_pi[lang] +`">`+ t.footermail_pi[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_osaka[lang] + t.footertel_osaka[lang] +`</span> <a href="mailto:`+ t.footermail_osaka[lang] +`">`+ t.footermail_osaka[lang] +`</a>)</dd>
  <dd><span>`+ t.footer_fukuoka[lang] + t.footertel_fukuoka[lang] +`</span> <a href="mailto:`+ t.footermail_fukuoka[lang] +`">`+ t.footermail_fukuoka[lang] +`</a>)</dd>
  `
  $('#box_officework').html(contactlist);
  // 来場予定表示
  const showsJqXHR = getShowsJqXHR();
  $.when(showsJqXHR)
    .done((jqShows) => {
      const shows: Shows[] = jqShows;
      let exhibitionName :string = "";
      
      // 該当する展示会を検索
      shows.forEach( (value: Shows) => {
        let regist_start = new Date(value.regist_start);
        let regist_end = new Date(value.regist_end);
        let today = new Date();
        let date_sddress = value.date_name ? value.date_name : "";
        //date_sddress += value.show_address ? t.cv_venue[lang]+"："+value.show_address : "";
        let show_address = value.show_address ? value.show_address: "";
        let deadline_notion = value.deadline_notion ? value.deadline_notion: "";
        if((value.registable_status == 'yes')
          && (regist_start <= today)
          && (regist_end >= today)
          && (value.joinable_status == 'no')){
            exhibitionName += `
            <div class="box_exhibition row" id="current_${value.tenji_key}">
              <div class="box2 col-md-4 my-auto">
                <div>
                  <img class="img_exhibition" src="${value.tenji_img}">
                </div>
              </div>
              <div class="box1 col-md-8 my-auto">
                <div>
                  <p class="font-weight-bold" style="font-size: 1rem;">${value.tenji_name}</p>
                  ${date_sddress}<br/>
                  ${show_address}<br/>
                  <p style="color: red; font-weight:bold;">${deadline_notion}</p>
                </div>
              </div>
            </div>`;
        }
        else if((value.registable_status == 'yes')
          && (regist_start <= today)
          && (regist_end >= today)
          && (value.joinable_status == 'yes')){
            exhibitionName += `
            <div class="box_exhibition row" id="current_${value.tenji_key}">
              <div class="box2 col-md-4 my-auto">
                <div>
                  <img class="img_exhibition" src="${value.tenji_img}">
                </div>
              </div>
              <div class="box1 col-md-8 my-auto">
                <div>
                  <p class="font-weight-bold" style="font-size: 1rem;">${value.tenji_name}</p>
                  ${date_sddress}<br/>
                  ${show_address}<br/>
                  <p style="color: red;">${deadline_notion}</p>
                  <div class="mt-3 exhibition-apply">  
                    <a id=${value.tenji_key} class="btn-show trn" style="cursor: pointer" data-shows=${value.tenji_key} data-trn-key="apply_now" target="_blank">
                      ${t.apply_now[lang]}
                    </a>
                  </div>
                </div>
              </div>
            </div>`;
        }
      });

      if( exhibitionName !== "" ){
        // ヘッダーへ
        $('#exhibition').html(exhibitionName);
      }else{
        alert('展示会情報がありません。')
      }
      //scroll
      var regex = new RegExp("[?&]" + "show_code" + "(=([^&#]*)|&|#|$)");
      var results = regex.exec(window.location.href);
      if(results && results[2]){
        let url_showcode = decodeURIComponent(results[2].replace(/\+/g, " "));
        if (url_showcode != "" && url_showcode != null) {
          let anchorElement = $("#current_"+url_showcode);
          if(anchorElement) {
            $('html, body').animate({
              scrollTop: anchorElement.get(0).offsetTop+140
            }, 1000);
          };
        };
      };

      //exhibitor
      
    })
    .fail(() => {
      //alert('展示会情報の読込に失敗しました。事務所窓口までご連絡下さい。');
      alert('展示会情報の読込に失敗しました。（株）ビジネスガイド社GiftNet事業部（giftnet@giftshow.co.jp）までご連絡下さい。');
    })
    .always(() => {
      $('#selection-wrapper .btn-show').on("click", function (e){
        localStorage.setItem('exhibition', e.target.dataset['shows'] as string);
        window.location.href = `./signup/phoneVerification.html`;
      })
    });

  $('#giftnet_link').on('click', () => {
    localStorage.setItem('exhibition', "giftnet");
    window.location.href = `./signup/phoneVerification.html`;
  });

  translate(); // 翻訳
  $('#loading').hide(); // ロードを解除

});

